module.exports = __webpack_public_path__ + "img/gallery_image-1.7b7bb3f.jpg";